import React, { useState } from 'react';
import { HookSlide } from './components/HookSlide';
import { QuizSlide } from './components/QuizSlide';
import { RewardSlide } from './components/RewardSlide';
import { DeepDiveSlide } from './components/DeepDiveSlide';
import { ColumviCtaSlide } from './components/ColumviCtaSlide';
type SlideType = 'hook' | 'quiz' | 'reward' | 'deepdive' | 'cta';
export function App() {
  const [currentSlide, setCurrentSlide] = useState<SlideType>('hook');
  const [selectedAnswer, setSelectedAnswer] = useState<string | null>(null);
  const [isCorrect, setIsCorrect] = useState(false);
  const handleExplore = () => {
    setCurrentSlide('quiz');
  };
  const handleAnswerSelect = (answerId: string) => {
    setSelectedAnswer(answerId);
    setIsCorrect(answerId === 'b');
    setCurrentSlide('reward');
  };
  const handleRewardContinue = () => {
    setCurrentSlide('deepdive');
  };
  const handleDeepDiveContinue = () => {
    setCurrentSlide('cta');
  };
  return <div className="min-h-screen w-full flex justify-center items-center p-4" style={{
    background: '#1a1a2e'
  }} data-id="element-0">
      <div className="w-full max-w-[400px] aspect-[9/16] relative overflow-hidden shadow-2xl rounded-2xl bg-black" data-id="element-1">
        {currentSlide === 'hook' && <HookSlide onExplore={handleExplore} data-id="element-2" />}

        {currentSlide === 'quiz' && <QuizSlide onAnswerSelect={handleAnswerSelect} data-id="element-3" />}

        {currentSlide === 'reward' && <RewardSlide isCorrect={isCorrect} selectedAnswer={selectedAnswer || ''} onContinue={handleRewardContinue} data-id="element-4" />}

        {currentSlide === 'deepdive' && <DeepDiveSlide onFinish={handleDeepDiveContinue} data-id="element-5" />}

        {currentSlide === 'cta' && <ColumviCtaSlide heading="Explore how COLUMVI + GemOx is redefining outcomes in 2L+ DLBCL" subheading="Review efficacy data, mechanism of action, and clinical positioning." primaryLabel="View full evidence" primaryUrl="https://www.columvi-hcp.com/efficacy/trial-information.html" secondaryLabel="Explore mechanism of action" secondaryUrl="https://www.columvi-hcp.com/about/how-columvi-works.html" data-id="element-6" />}
      </div>
    </div>;
}